import { useQuery } from "@tanstack/react-query";

import { dashboardLayoutApi } from "@/lib/api/dashboardLayout";
import { qk } from "@/lib/query-client";
import { Spinner } from "@/components/ui/Spinner";
import { DashboardPage } from "../DashboardPage";
import { CustomDashboard } from "./CustomDashboard";

/**
 * Which dashboard the "/" route shows. A company that never saved a layout
 * gets the original DashboardPage exactly as it always was; one that did gets
 * its own arrangement. If the layout cannot be read for any reason the
 * original dashboard is shown - customization can never leave anyone without
 * a working dashboard.
 */
export function DashboardEntry() {
  const { data, isLoading } = useQuery({ queryKey: qk.dashboardLayout, queryFn: dashboardLayoutApi.get, staleTime: 60_000, retry: false });
  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="h-6 w-6 text-primary-600" />
      </div>
    );
  }
  if (!data || !data.customized || !data.layout) return <DashboardPage />;
  return <CustomDashboard view={data} />;
}
